$(document).ready(function () {
  $(document).ready(function () {
  $('#collection-search').on('input', function () {
    let query = $(this).val();
    let collectionHandle = window.location.pathname.split('/')[2]; // e.g., "shirts"

    if (query.length > 1) {
      $.ajax({
        url: `/search/suggest.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor&resources[options][collection_handle]=${collectionHandle}`,
        method: 'GET',
        success: function (data) {
          let results = data.resources.results.products;
          let html = '';
          $('#CollectionAjaxResult').hide();
          $('.show-all-btn').hide();
          if (results.length) {
            results.forEach(product => {
              const imageUrl = product.image || 'https://via.placeholder.com/300x400?text=No+Image';
              const productUrl = product.url;
              const productTitle = product.title;
              const productHandle = product.handle;
              const productId = product.id;

              html += `
              <div class="grid__item grid-product small--one-half medium-up--one-quarter grid-product__has-quick-shop aos-init aos-animate" data-aos="row-of-4" data-product-handle="${productHandle}" data-product-id="${productId}">
                <div class="grid-product__content">
                  <button class="quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-${productId} small--hide">
                    <span class="quick-product__label">Quick view</span>
                  </button>
                  <a href="${productUrl}" class="grid-product__link">
                    <div class="grid-product__image-mask">
                      <div class="image-wrap loaded" style="height: 0; padding-bottom: 120%;">
                        <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
                          <img src="${imageUrl}" alt="${productTitle}" width="1080" loading="lazy" class="grid-product__image image-style--image-element">
                        </image-element>
                      </div>
                    </div>
                  </a>
                  <div class="grid-product__meta">
                    <a href="${productUrl}" class="grid-product__link">
                      <div class="quick-product__btn js-modal-open-quick-modal-${productId} small--hide" data-product-id="${productId}">
                        <span class="quick-product__label">Quick view</span>
                      </div>
                    </a>
                    <div class="custom_add-to-cart">
                      <a class="add-to-cart" href="${productUrl}">Go to listing</a>
                    </div>
                    <div class="grid-product__title">${productTitle}</div>
                  </div>
                </div>
              </div>`;
            });
          } else {
            html = '<p>No results found</p>';
          }

          $('#collection-results').html(html);
        }
      });
    } else {
      $('#collection-results').empty();
      $('#CollectionAjaxResult').show();
      $('.show-all-btn').show();
    }
  });
});

});

$(document).ready(function(){

  if($('.product__thumb-item').length > 4){
    $('.product__thumb-arrow').show();
  }else{
    $('.product__thumb-arrow').hide();
  }
  // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function (k, v) {
    $(v).find('.tab_content:first').show();
  });

  /* if in tab mode */
  $("ul.tabs li").click(function () {
    var parent = $(this).parents('.tab-container');

    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#" + activeTab).fadeIn();

    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

    $('.tab-slider-main').slick('refresh');

  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function () {
    var parent = $(this).parents('.tab-container');

    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#" + d_activeTab).fadeIn();

    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");

    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
  });


  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");
$('.review-main-item').slick({
  dots: true,
  infinite: true,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.custom_grid').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1220,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

/*
$('.product-main-slider-img').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight:true,
  asNavFor: '.product__thumb-slider'
});
$('.product__thumb-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  asNavFor: '.product-main-slider-img',
  dots: true,
  focusOnSelect: true,
  
            prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        
  responsive: [

    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});*/
// 


    var url= window.location.href; 
    var array = url.split("/");
    var lastItem = array.pop();
    if (window.location.href.indexOf("policies") > -1) {
      $('body').addClass(lastItem);
    }

 /*$('.variant-input-wrap').each(function(){
    $('input[type=radio]:first', this).attr('checked', true);
});*/
  // $('.accesories-add-to-cart-btn').click(function(){
  //   var form_id = $(this).attr('id');
  //   $('#'+form_id).on('submit', function(e){ 
  //     e.preventDefault(); 
  //     var jsondata = $(this).find('.variant-json-data').text();
  //     var data = JSON.parse(jsondata);
  //     if(data.length > 1){
  //       var variant_id = $(this).find('.variant_radio_btn:checked').attr('value');
  //     }else{
  //       var variant_id = $(this).find('.variant_radio_btn').attr('value');
  //     }
  //        $.ajax({
  //           type:"post",
  //           url:"/cart/add.js",
  //           data:{id: variant_id},
  //           success: function(data){
  //           $('body').trigger('added.ajaxProduct');
  //             console.log(data);
  //         }
  //      });      
  //  });
  // });
  
});

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get("q");

  if (query) {
    const searchTerm = query.toLowerCase();
    const items = document.querySelectorAll(".grid__item");

    let matchFound = false;

    items.forEach(item => {
      const titleEl = item.querySelector(".grid-product__title");
      const title = titleEl?.textContent.toLowerCase() || "";

      if (title.includes(searchTerm)) {
        item.style.display = "";
        matchFound = true;
      } else {
        item.style.display = "none";
      }
    });

    if (!matchFound) {
      document.querySelector(".product-grid-container").insertAdjacentHTML(
        "beforeend",
        '<div class="no-results">No matching products found.</div>'
      );
    }
  }
  
});


  function toggleDropdown() {
    var menu = document.getElementById('dropdown-content');
    menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
  }

  // Optional: close dropdown when clicking outside
  document.addEventListener('click', function(event) {
    var dropdown = document.getElementById('dropdown-menu');
    if (dropdown) {
      if (!dropdown.contains(event.target)) {
        document.getElementById('dropdown-content').style.display = 'none';
      }
    }
  });
